export default __webpack_public_path__ + "static/media/webinar_thumb_02.40635e65.jpg";